import React from 'react';

// A reusable platform-styled replacement for window.confirm()/prompt().
// Pass `reason`/`onReasonChange` to collect a short text reason (e.g. ban
// reason, rejection reason) instead of a raw children render-prop, since
// that's the vast majority of admin confirm-with-input use cases.
const ConfirmDialog = ({
  open,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  danger = false,
  reason,
  onReasonChange,
  reasonLabel,
  reasonPlaceholder = 'Reason...',
  reasonRequired = false,
  confirmDisabled = false,
  onConfirm,
  onCancel,
  children
}) => {
  if (!open) return null;

  const isConfirmDisabled = confirmDisabled || (reasonRequired && !reason?.trim());

  return (
    <div
      className="fixed inset-0 z-[90] flex items-center justify-center bg-black/50 p-4"
      onClick={onCancel}
    >
      <div
        className="bg-white rounded-lg shadow-xl max-w-md w-full p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="text-lg font-semibold text-dim mb-2">{title}</h3>
        {message && <p className="text-sm text-dim-light mb-4">{message}</p>}

        {onReasonChange && (
          <div className="mb-4">
            {reasonLabel && <label className="block text-sm font-medium text-dim mb-1">{reasonLabel}</label>}
            <textarea
              value={reason || ''}
              onChange={(e) => onReasonChange(e.target.value)}
              placeholder={reasonPlaceholder}
              rows={3}
              className="w-full p-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-accent-hard resize-none"
            />
          </div>
        )}

        {children}

        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={onCancel}
            className="px-4 py-2 rounded-lg border border-gray-300 text-sm text-dim hover:bg-gray-50"
          >
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            disabled={isConfirmDisabled}
            className={`px-4 py-2 rounded-lg text-sm font-medium text-white disabled:opacity-50 disabled:cursor-not-allowed ${
              danger ? 'bg-red-600 hover:bg-red-700' : 'bg-primary-dark hover:bg-accent-hard'
            }`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
